var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.999C6.6879 11.015 5.38936 10.7369 4.2032 10.1859C3.28375 9.74533 2.45812 9.13693 1.7704 8.39315C1.04195 7.62415 0.468374 6.72664 0.08 5.74806L0 5.49981L0.084 5.25156C0.472652 4.27384 1.04499 3.37656 1.7712 2.60647C2.45867 1.86276 3.28403 1.25435 4.2032 0.813744C5.38937 0.26272 6.6879 -0.0153627 8 0.000654691C9.31209 -0.0153351 10.6106 0.262746 11.7968 0.813744C12.7163 1.25425 13.5419 1.86266 14.2296 2.60647C14.9594 3.37443 15.5332 4.27221 15.92 5.25156L16 5.49981L15.916 5.74806C14.661 8.95625 11.4994 11.0534 8 10.999ZM8 1.57184C5.2767 1.48804 2.77713 3.0449 1.6936 5.49981C2.77696 7.95486 5.27663 9.5118 8 9.42778C10.7232 9.51136 13.2227 7.95457 14.3064 5.49981C13.2243 3.04371 10.7238 1.48627 8 1.57184ZM8 7.85659C6.84586 7.86409 5.84749 7.06892 5.61677 5.95842C5.38605 4.84791 5.98742 3.73224 7.05231 3.29517C8.1172 2.85809 9.34819 3.22169 9.99084 4.16313C10.6335 5.10456 10.5083 6.36088 9.692 7.16213C9.24506 7.60619 8.63581 7.85625 8 7.85659Z",
    fill: "#052987"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.cb738450380022e7300c6e1d22d33319.svg";
export { ForwardRef as ReactComponent };